import React from "react";
import { InspectionTypeMap } from "../../utils/enums";
import { formatDate } from "../../utils/date";
import AutosledLogo from "./Images/AutosledLogo";
import DeletedTag from "../DeletedTag/DeletedTag";

const Header = ({ inspectionData, inspectionType }) => {
  return (
    <div className="header row">
      <div className="header__left col">
        <div className="header__title">
          <span>Bill of Lading</span>
          {inspectionData.isDeleted && <DeletedTag />}
        </div>
        <div className="header__subtitle">
          {InspectionTypeMap[inspectionType]} Inspection:{" "}
          {formatDate(inspectionData.completedAt)}
        </div>
        <span className="header__subtitle">
          <span className="header__label">Load ID:&nbsp;&nbsp;</span>
          <span className="header__data">{inspectionData.loadId}</span>
        </span>
        <span className="header__subtitle">
          <span className="header__label">Shipper:&nbsp;&nbsp;&nbsp;</span>
          <span className="header__data">{inspectionData.dealerName}</span>
        </span>
      </div>

      <div className="header__right row">
        {/* AUTOSLED LOGO IMAGE */}
        <span className="logo-container">
          <AutosledLogo />
        </span>

        <div className="col">
          <span className="header__address-line">Autosled, Inc</span>
          <span className="header__address-line">6010 Executive Blvd</span>
          <span className="header__address-line">Rockville, MD, 20852</span>
          <span className="header__address-line">240-880-2702</span>
        </div>
      </div>
    </div>
  );
};

export default Header;
